import type { ArtifactRefIn } from "../../api/types/onboardingRun";
import type { RenderBundleOut } from "../../api/types/renderBundle";

// UI adapter metadata for the single run type the cockpit can create today.
// The backend registry remains authoritative; this maps render artifact names to
// the create_run input names until a backend run-type descriptor endpoint exists.
export interface RunTypeDescriptor {
  run_type: string;
  run_type_version: number;
  artifact_schema_version: number;
  // "api" runs execute in-process in the Hub (no playbook_commit — executor_ref
  // is server-stamped). "ansible" runs pin a 40-hex git sha.
  executionKind: "ansible" | "api";
  inputs: ReadonlyArray<{ render: string; create: string }>;
}

// Deprecated/bridge-only: the legacy ansible identity entrypoint.
export const IDENTITY_ONBOARDING: RunTypeDescriptor = {
  run_type: "identity_onboarding",
  run_type_version: 1,
  artifact_schema_version: 1,
  executionKind: "ansible",
  inputs: [{ render: "request.yml", create: "control_plane_request" }],
};

// Hub-native, API-only identity onboarding (the default path for new tenants).
export const IDENTITY_ONBOARDING_API: RunTypeDescriptor = {
  run_type: "identity_onboarding_api",
  run_type_version: 1,
  artifact_schema_version: 1,
  executionKind: "api",
  inputs: [{ render: "request.yml", create: "control_plane_request" }],
};

export function buildRunArtifacts(
  descriptor: RunTypeDescriptor,
  bundle: RenderBundleOut,
): ArtifactRefIn[] {
  return descriptor.inputs.map((input) => {
    const artifact = bundle.artifacts.find((a) => a.name === input.render);
    if (!artifact) {
      throw new Error(`render bundle is missing the '${input.render}' artifact`);
    }
    return { name: input.create, content_sha256: artifact.content_sha256 };
  });
}
